package top.wcpe.allincore.ui.runtime.ir.api

import top.wcpe.allincore.ui.runtime.reactive.Signal
import kotlin.jvm.JvmField

/** DSL 中 local 内建对象暴露的本地音效能力。 */
interface LocalSoundApi {
    /** 播放本地二维音效；资源位置非法时返回 false。 */
    fun playSound(soundId: String, volume: Double, pitch: Double): Boolean = false
}

/** DSL 中 local 内建对象暴露的本地能力。 */
interface LocalApi : LocalSoundApi {
    fun openScreen(id: String)
    fun back()
    fun disconnect() {}
    fun quitGame() {}
    fun close()
    fun player(): Map<String, Signal<Any?>>
    fun boss(): Map<String, Signal<Any?>> = emptyMap()
    fun setInteractionMode(enabled: Boolean) {}
    fun warpCursor(guiX: Double, guiY: Double) {}
    fun viewport(): Map<String, Signal<Any?>> = emptyMap()

    /**
     * 按 key 执行服务端 `ui-commands.yml` 中配置的命令（fire-and-forget）。
     *
     * 客户端只发 key，服务端按 key 查配置（命令列表 / 控制台或玩家身份 / 冷却）并执行；
     * 白名单语义：只有配置过的 key 能跑，客户端无法执行任意命令。
     */
    fun command(key: String) {}

    /**
     * 打开原版 Screen。name 为预定义白名单：
     * - "advancements"：进度屏
     * - "stats"：统计屏
     * - "shareToLan"：分享到局域网屏（仅单机未发布时有效）
     * - "social"：玩家举报/社交屏
     * - "options"：原版选项屏
     *
     * 未识别的 name 静默忽略（NOOP），避免 DSL 误调用导致崩溃。
     */
    fun openVanillaScreen(name: String) {}

    /**
     * 用系统默认浏览器打开外部链接 [url]。
     *
     * 与原版 ConfirmLinkScreen「打开链接」按钮语义一致：直接打开，不弹确认框。
     * 调用方负责确保 [url] 是合法可信任的 URL。
     */
    fun openUri(url: String) {}

    companion object {
        @JvmField val NOOP: LocalApi = object : LocalApi {
            override fun openScreen(id: String) {}
            override fun back() {}
            override fun close() {}
            override fun player(): Map<String, Signal<Any?>> = emptyMap()
        }
    }
}
